import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { HomeState } from '@/types/home/types';

import { fetchAcessos, fetchHomeData, getDashboardSearch, registrarAcesso } from './services';

const initialState: HomeState = {
  currentPath: '/',
  dropdownOpen: false,
  loading: false,
  error: null,
  data: null,
  searchQuery: '',
  searchResults: [],
  searchLoading: false,
  acessos: [],
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setDropdownOpen: (state, action: PayloadAction<boolean>) => {
      state.dropdownOpen = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCurrentPath: (state, action: PayloadAction<string>) => {
      state.currentPath = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    clearSearch: (state) => {
      state.searchQuery = '';
      state.searchResults = [];
      state.searchLoading = false;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomeData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.data = action.payload;
      })
      .addCase(fetchHomeData.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || 'Erro ao carregar dados da dashboard';
      })
      .addCase(getDashboardSearch.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(getDashboardSearch.fulfilled, (state, action) => {
        state.searchLoading = false;
        state.searchResults = action.payload;
      })
      .addCase(getDashboardSearch.rejected, (state) => {
        state.searchLoading = false;
        state.searchResults = [];
      })
      .addCase(fetchAcessos.fulfilled, (state, action) => {
        state.acessos = action.payload;
      })
      .addCase(registrarAcesso.fulfilled, (state, action) => {
        const novoAcesso = action.payload;
        state.acessos = state.acessos.filter((a) => a.rota !== novoAcesso.rota);
        state.acessos.unshift(novoAcesso);
      });
  },
});

export const { setSearchQuery, clearSearch } = homeSlice.actions;
export const homeReducer = homeSlice.reducer;
